import axios from "axios"
const apiURL = `https://members.eccourts.org`
const middleWare = `http://localhost:2700`
import authService from '@/services/authService'

export const whoIsIn = () => {
  const token = authService.getCookie("wcmCookie")
  let url = `${apiURL}/wp-json/wp/v2/pages/2`  
   return axios.get(url, {
    headers:{
      "Authorization": 'Bearer'+token 
    }
   })
}
export const getTraining = (id) => {
  if(!id) {
    let url = `${middleWare}/training/all`
    return axios.get(url)
  } else {
    let url = `${middleWare}/training/${id}`
    return axios.get(url)
  }
}
export const registerForTraining = (id, payload) => {
  if(id) {
    let token = authService.getCookie('wcmCookie')
    let url = `${middleWare}/training/register/${id}`
    return axios.post(url, payload, {
      headers:{
        Authorization:'Bearer'+token
      }
    })
  } 
}
export const  formMailService = async (id, payload) => {
  let formData = new FormData()
  if(typeof payload !== 'object') {
    throw {error:'Wrong type of data check payload'}
  }
  Object.keys(payload).forEach(property => {
    formData.append(property, payload[property])
  })
  let config = {
    headers: {
      'Content-Type': undefined,
      'Accept': 'application/json, text/javascript, */*;q=0.01'
    }
  }
const data = await axios.post(`${apiURL}/wp-json/contact-form-7/v1/contact-forms/${id}/feedback/`, formData, config)
  return data
 }